import type {ErrorMessage} from 'angular-error-repository';

export const TelephoneNumberError: ErrorMessage = err => {
    return `Error.Telephone number.${err.error}`;
};
